import storeHelpers from '../helpers'

export const reports = {
  namespaced: true,
  state () {
    return {
      reportWeightings: {},
      reportWeightingsSubscription: null
    }
  },
  mutations: {
    setReportWeightingsById (state, data) {
      storeHelpers.setNameById(state, data, 'reportWeightings')
    },
    setReportWeightingsSubscription (state, data) {
      storeHelpers.setNameSubscription(state, data, 'reportWeightings')
    }
  },
  actions: {
    subscribeReportWeightings ({ commit, state }) {
      storeHelpers.subscribeByName(commit, state, 'reportWeightings')
    },  
    unsubscribeReportWeightings ({ commit, state }) {
      storeHelpers.unsubscribeByName(commit, state, 'reportWeightings')
    }
  },
  getters: {
  }
}
